import * as React from 'react';
import { ThemeProviderCore, ThemeContext, useTheme, } from '@core-front/theme-provider';
const breakPoints = {
    xs: 320,
    sm: 600,
    md: 800,
    lg: 1000,
    xl: 1288,
    xxl: 1450,
};
const ThemeProvider = (props) => {
    return (React.createElement(ThemeProviderCore, Object.assign({}, props, { breakPoints: breakPoints })));
};
export { ThemeProvider as default, ThemeContext, useTheme, breakPoints, };
